<section>
  <p>
    Make sure you can see yourself in the video below. Test your microphone and speakers, and ensure that all checkmarks are green.
  </p>

  <section>
    <div class="responsive-container">
      <div class="video-container">
        <ng-container *ngTemplateOutlet="videoContainer" />
      </div>

      <div class="form-container">
        <app-video-selection></app-video-selection>
        <app-audio-select></app-audio-select>
        <app-button-container>
          @if (useDefaultActions()) {
          <app-button
            (buttonClick)="continue()"
            [dataTestId]="'next-button-avcheck'"
            [isDisabled]="sharedComponentService.isContinueDisabled()"
            type="primary"
          >
            Next
          </app-button>
          } @else {
          <ng-content></ng-content>
          }
        </app-button-container>
      </div>
    </div>
  </section>
</section>

<ng-template #videoContainer>
  @if (sharedComponentService.isVideoDetected()) {
  <video
    [autoplay]="true"
    [controls]="false"
    [muted]="true"
    [playsInline]="true"
    [srcObject]="sharedComponentService.mediaStream()"
    class="video-list"
  ></video>
  } @else {
  <img
    src="./assets/images/no-video-detected.svg"
    alt="No Video Detected"
    title="Video not detected"
  />
  }
</ng-template>